import { CSRF_HEADER } from '@common/csrf-header';
import { createORPCClient, type InferClientErrors } from '@orpc/client';
import type { ContractRouterClient } from '@orpc/contract';
import { OpenAPILink } from '@orpc/openapi-client/fetch';
import { createTanstackQueryUtils } from '@orpc/tanstack-query';
import areYouOk from '@server/are-you-ok/are-you-ok.router';
import chat from '@server/chat/chat.router';
import insurancePolicy from '@server/insurance-policy/insurance-policy.router';
import pnr from '@server/pnr/pnr.router';

// Create a combined contract router
const contract = {
  insurancePolicy,
  areYouOk,
  chat,
  pnr,
};

// Create the OpenAPI link with the contract
const link = new OpenAPILink(contract, {
  url: `${window.location.origin}/api`,
  headers: () => CSRF_HEADER,
});

// Create the orpc client with explicit typing for type inference
const client = createORPCClient<ContractRouterClient<typeof contract>>(link);

export type ClientErrors = InferClientErrors<typeof client>;

// Create TanStack Query utils
export const orpc = createTanstackQueryUtils(client);
